// src/pages/MeetInfo.js
import React from 'react';

function MeetInfo() {
  // Easy to update these details for each meet
  const meetDetails = {
    name: "Bullseye Striders Maryland Youth XC Regional Championship",
    date: "Sunday, November 1, 2026",
    location: "Burleigh Manor Middle School",
    address: "4200 Centennial Lane, Ellicott City, MD 21042",
    flyerLink: "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fstorage.googleapis.com%2Fanet_user_files%2Fmeet%2Fxc%2F288116%2F2026BullseyeHomeXCMeet.doc&wdOrigin=BROWSELINK",
    courseMapLink: "https://www.google.com/maps/d/u/0/viewer?ll=39.252448122867584,-76.8712920055716&z=17&mid=1ONpLyG1SZZwM1IZIjd9WDEXs7Ts1enY",
    liveResultsLink: "https://live.bullseyerunning.com/meets/78103",

    fee: "$12 per athlete",
    feeBreakdown: "$10 meet entry + $2 club fee",
    signUpDeadline: "Wednesday, October 28",     // when Coach Dario needs your name
    registrationCloses: "Thursday, October 29",  // the meet closes entries 11:59pm

    // Weekly sign-up form. Same link every meet—the form is retitled, not rebuilt.
    signUpFormUrl: "https://docs.google.com/forms/d/e/1FAIpQLSfZquQ07CLBmjPgfQLmMeNUbLpbCw52SAp_FE2GTfrKgB3pvw/viewform",

    // Age group is set by the athlete's age on 12/31/2026.
    // "arrive" is Coach Dario's recommendation: one hour before your race.
    // Same venue and same schedule as the Oct 11 Bullseye meet at this field.
    raceSchedule: [
      { group: "6 & under Boys & Girls",     distance: "1K (0.62 mi)", start: "12:00 PM", arrive: "11:00 AM" },
      { group: "7/8 Boys & Girls",           distance: "2K (1.24 mi)", start: "12:15 PM", arrive: "11:15 AM" },
      { group: "9/10 Girls",                 distance: "3K (1.86 mi)", start: "12:40 PM", arrive: "11:40 AM" },
      { group: "9/10 Boys",                  distance: "3K (1.86 mi)", start: "1:10 PM",  arrive: "12:10 PM" },
      { group: "11/12 Girls",                distance: "3K (1.86 mi)", start: "1:40 PM",  arrive: "12:40 PM" },
      { group: "11/12 Boys",                 distance: "3K (1.86 mi)", start: "2:10 PM",  arrive: "1:10 PM" },
      { group: "13/14 & 15–18 Girls",        distance: "4K (2.48 mi)", start: "2:35 PM",  arrive: "1:35 PM" },
      { group: "13/14 & 15–18 Boys",         distance: "4K (2.48 mi)", start: "3:10 PM",  arrive: "2:10 PM" }
    ]
  };

  return (
    <div className="page" style={{ maxWidth: '100%', padding: '0' }}>
      {/* Hero Section - Meet Name & Details */}
      <div style={{
        background: 'linear-gradient(135deg, #2A4BA0 0%, #4299E1 100%)',
        padding: '2rem 1.5rem',
        textAlign: 'center',
        marginBottom: '1.5rem',
        color: 'white',
        boxShadow: '0 4px 15px rgba(42, 75, 160, 0.3)'
      }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>🍂</div>
        <h1 style={{
          color: 'white',
          marginBottom: '0.75rem',
          fontSize: '1.8rem',
          fontWeight: 'bold',
          lineHeight: '1.2'
        }}>
          {meetDetails.name}
        </h1>
        <div style={{
          fontSize: '1.1rem',
          fontWeight: '600',
          marginBottom: '0.5rem',
          opacity: 0.95
        }}>
          📅 {meetDetails.date}
        </div>
        <div style={{
          fontSize: '1rem',
          opacity: 0.9,
          marginTop: '0.75rem'
        }}>
          📍 {meetDetails.location}
          <br/>
          <span style={{ fontSize: '0.9rem', opacity: 0.85 }}>
            {meetDetails.address}
          </span>
        </div>
      </div>

      {/* Flyer and Map Links */}
      <div style={{
        padding: '0 1.5rem',
        marginBottom: '1.5rem'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: '1rem'
        }}>
          <a
            href={meetDetails.flyerLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#c53030',
              color: 'white',
              padding: '1.25rem 1rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: 'bold',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(197, 48, 48, 0.3)'
            }}
          >
            <span style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>📄</span>
            <span style={{ fontSize: '0.95rem' }}>View Meet Flyer</span>
          </a>

          {meetDetails.liveResultsLink && (
            <a
              href={meetDetails.liveResultsLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#b45309',
                color: 'white',
                padding: '1.25rem 1rem',
                borderRadius: '12px',
                textDecoration: 'none',
                fontWeight: 'bold',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(180, 83, 9, 0.3)'
              }}
            >
              <span style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>⏱️</span>
              <span style={{ fontSize: '0.95rem' }}>Live Results</span>
            </a>
          )}

          {meetDetails.courseMapLink && (
            <a
              href={meetDetails.courseMapLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#2f855a',
                color: 'white',
                padding: '1.25rem 1rem',
                borderRadius: '12px',
                textDecoration: 'none',
                fontWeight: 'bold',
                textAlign: 'center',
                boxShadow: '0 4px 12px rgba(47, 133, 90, 0.3)'
              }}
            >
              <span style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🏃</span>
              <span style={{ fontSize: '0.95rem' }}>Course Map</span>
            </a>
          )}

          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(meetDetails.address)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#2A4BA0',
              color: 'white',
              padding: '1.25rem 1rem',
              borderRadius: '12px',
              textDecoration: 'none',
              fontWeight: 'bold',
              textAlign: 'center',
              boxShadow: '0 4px 12px rgba(42, 75, 160, 0.3)'
            }}
          >
            <span style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🗺️</span>
            <span style={{ fontSize: '0.95rem' }}>Open in Maps</span>
          </a>
        </div>
      </div>

      {/* Sign-up and payment — the part families must act on */}
      <div style={{ padding: '0 1.5rem', marginBottom: '1.5rem' }}>
        <div className="content-section" style={{
          background: '#fffaf0',
          border: '2px solid #fbd38d',
          borderLeft: '6px solid #d69e2e',
          padding: '1.5rem',
          borderRadius: '12px'
        }}>
          <h2 style={{
            color: '#d69e2e',
            fontSize: '1.4rem',
            marginBottom: '1rem'
          }}>
            ✍️ Signing Up & Paying
          </h2>

          <div style={{
            background: 'white',
            padding: '1rem',
            borderRadius: '8px',
            marginBottom: '1rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '0.95rem', lineHeight: '1.7', color: '#333' }}>
              • <strong>Don't register on your own.</strong> Coach Dario enters every DC Hawks athlete<br/>
              • <strong>Sign up by {meetDetails.signUpDeadline}</strong> so there's time to enter everyone<br/>
              • <strong>{meetDetails.fee}</strong>, paid to Coach Dario ({meetDetails.feeBreakdown})<br/>
              • Venmo <strong>@dario-caldara</strong> or Zelle <strong>dario.caldara@gmail.com</strong>
            </div>
          </div>

          {/* Sign-up form button, once the weekly form link is set above */}
          {meetDetails.signUpFormUrl ? (
            <a
              href={meetDetails.signUpFormUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'block',
                background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
                color: 'white',
                padding: '1.25rem 1rem',
                borderRadius: '12px',
                textDecoration: 'none',
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '1.15rem',
                marginBottom: '1rem',
                border: '2px solid #15803d',
                boxShadow: '0 6px 18px rgba(22, 163, 74, 0.35)'
              }}
            >
              👉 Click Here to Sign Up for This Meet
            </a>
          ) : (
            <div style={{
              border: '2px dashed #d69e2e',
              color: '#92400e',
              padding: '1rem',
              borderRadius: '10px',
              textAlign: 'center',
              fontSize: '0.95rem',
              marginBottom: '1rem'
            }}>
              📝 Sign-up form link coming—watch WhatsApp
            </div>
          )}

          <div style={{
            background: '#fff5f5',
            border: '1px solid #fed7d7',
            padding: '0.85rem 1rem',
            borderRadius: '8px',
            fontSize: '0.95rem',
            color: '#742a2a'
          }}>
            ⚠️ Entries are <strong>non-refundable once registration closes</strong> on {meetDetails.registrationCloses}—
            the meet charges us whether or not your athlete runs.
          </div>
        </div>
      </div>

      {/* Race schedule */}
      <div style={{ padding: '0 1.5rem', marginBottom: '1.5rem' }}>
        <div className="content-section" style={{
          background: 'white',
          border: '2px solid #93c5fd',
          borderLeft: '6px solid #2A4BA0',
          padding: '1.5rem',
          borderRadius: '12px'
        }}>
          <h2 style={{ color: '#2A4BA0', fontSize: '1.4rem', marginBottom: '0.5rem' }}>
            ⏱️ Race Schedule
          </h2>
          <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '1.25rem' }}>
            Age group is set by how old your athlete is on <strong>December 31, 2026</strong>—
            not their age on race day.
          </p>

          {meetDetails.raceSchedule.map((race, i) => (
            <div key={i} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              gap: '0.75rem',
              padding: '0.4rem 0.6rem',
              background: i % 2 === 0 ? '#f8fafc' : 'white',
              borderRadius: '4px',
              fontSize: '0.9rem'
            }}>
              <span>
                <strong>{race.group}</strong>
                <span style={{ color: '#94a3b8' }}> · {race.distance.split(' ')[0]}</span>
              </span>
              <span style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
                <strong style={{ color: '#2A4BA0' }}>{race.start}</strong>
                <span style={{ color: '#94a3b8' }}> · arrive {race.arrive}</span>
              </span>
            </div>
          ))}

          <p style={{ fontSize: '0.9rem', color: '#666', marginTop: '1rem', marginBottom: 0 }}>
            This is a <strong>tentative schedule</strong> from the meet organizers—times may shift
            slightly before race day. Arrive early and stay near the start area.
          </p>

          {meetDetails.courseMaps && meetDetails.courseMaps.length > 0 && (
            <div style={{ marginTop: '1.25rem', paddingTop: '1rem', borderTop: '1px solid #e2e8f0' }}>
              <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.6rem' }}>
                🗺️ Interactive course maps (Strava), one per distance—or use the
                printable Course Map button above:
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {meetDetails.courseMaps.map((m, i) => (
                  <a
                    key={i}
                    href={m.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      background: '#eff6ff',
                      border: '1px solid #93c5fd',
                      color: '#2A4BA0',
                      padding: '0.4rem 0.9rem',
                      borderRadius: '20px',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      fontSize: '0.9rem'
                    }}
                  >
                    {m.label} route →
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Coach Dario's General Info */}
      <div style={{ padding: '0 1.5rem', marginBottom: '1.5rem' }}>
        <div className="content-section" style={{
          background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
          border: '2px solid #93c5fd',
          borderLeft: '6px solid #2A4BA0',
          padding: '1.5rem',
          borderRadius: '12px'
        }}>
          <h2 style={{
            color: '#2A4BA0',
            fontSize: '1.4rem',
            marginBottom: '1.5rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            👟 Coach Dario's Race Day Guide
          </h2>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}>
            {/* Timing */}
            <div style={{
              background: 'white',
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{
                fontWeight: 'bold',
                color: '#2A4BA0',
                marginBottom: '0.5rem',
                fontSize: '1rem'
              }}>
                ⏰ Arrival & Timing
              </div>
              <div style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                • <strong>Arrive one hour before your race</strong> (see the schedule above)<br/>
                • Find the team and check in with Coach Dario<br/>
                • <strong>Warm-up starts 45 minutes before the race</strong>
              </div>
            </div>

            {/* Food & Hydration */}
            <div style={{
              background: 'white',
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{
                fontWeight: 'bold',
                color: '#2A4BA0',
                marginBottom: '0.5rem',
                fontSize: '1rem'
              }}>
                🍎 Food & Hydration
              </div>
              <div style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                • <strong>No concessions at this meet</strong>—bring everything you need,
                including water<br/>
                • Eat a meal <strong>2-3 hours before the race</strong>—these are afternoon starts,
                so plan lunch accordingly<br/>
                • Bring <strong>1-2 snacks</strong> and a <strong>water bottle</strong>
              </div>
            </div>

            {/* What to Bring */}
            <div style={{
              background: 'white',
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{
                fontWeight: 'bold',
                color: '#2A4BA0',
                marginBottom: '0.5rem',
                fontSize: '1rem'
              }}>
                🎒 What to Bring
              </div>
              <div style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                • Dress appropriately for the weather<br/>
                • Bring a <strong>change of clothes</strong><br/>
                • Running gear (XC spikes optional)<br/>
                • A camp chair or blanket—it's a long afternoon between races
              </div>
            </div>

            {/* Meet-specific policies */}
            <div style={{
              background: 'white',
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{
                fontWeight: 'bold',
                color: '#2A4BA0',
                marginBottom: '0.5rem',
                fontSize: '1rem'
              }}>
                📋 Good to Know
              </div>
              <div style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                • Only a <strong>couple of portable toilets</strong> on site—plan ahead<br/>
                • Parents/coaches <strong>may not run alongside runners</strong>, except in the
                6 & under race<br/>
                • <strong>Medals</strong> for 1st & 2nd, <strong>ribbons</strong> 3rd–25th (2-year
                age groups for 7/8, 9/10, 11/12, 13/14); 6-under gets ribbons 1st–25th, 15-18 gets
                1st–5th—handed to Coach Dario after the meet, not on site<br/>
                • <strong>Rain or shine</strong>—we'll wait out any thunder or lightning
              </div>
            </div>

            {/* Support */}
            <div style={{
              background: 'white',
              padding: '1rem',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <div style={{
                fontWeight: 'bold',
                color: '#2A4BA0',
                marginBottom: '0.5rem',
                fontSize: '1rem'
              }}>
                💬 Need Help?
              </div>
              <div style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#333' }}>
                If you have questions or need help with logistics, send a message on the <strong>DC Hawks WhatsApp chat</strong>—someone will help!
              </div>
            </div>
          </div>

          {/* Most Important */}
          <div style={{
            background: 'linear-gradient(135deg, #c53030 0%, #e53e3e 100%)',
            color: 'white',
            padding: '1.25rem',
            borderRadius: '12px',
            textAlign: 'center',
            marginTop: '1.5rem',
            fontWeight: 'bold',
            fontSize: '1.1rem',
            boxShadow: '0 4px 12px rgba(197, 48, 48, 0.3)'
          }}>
            🎉 Most importantly: Enjoy and have fun! 🎉
          </div>
        </div>
      </div>
    </div>
  );
}

export default MeetInfo;
